import React, { useState, useEffect } from "react";
import System from 'src/helper/system';
import { profileStore } from 'src/hooks/profile';
import Constants from 'src/helper/Constants';
import Helper from "../../helper/Helper";
import { useAxiosIndicatorCheck } from "../../store/hook/useAxiosIndicatorCheck";
import { useDOMAttachToSystemStore } from "src/hooks/domAttachToSystem";

const AddressInformation = () => {
    const { siteUser: { WEB, CORE }, addressType } = Constants
    const [{ profile_account_information }, { get_profile_account_information }, { set_account_address_default }] = profileStore();
    const [invoiceAddress, setInvoiceAddress] = useState([])
    const [shippingAddress, setShippingAddress] = useState([])
    const { avUserInfoData: { currentUser, salesOrg, accountNumber }} = System
    const isWebAndCoreUser = currentUser === WEB || currentUser === CORE
    const isWebUser = currentUser === WEB
    const isCoreUser = currentUser === CORE
    const [__check] = useAxiosIndicatorCheck();
    const [{ }, { system_alert_indicator,clear_all_system_alert }, { }] = useDOMAttachToSystemStore();

    useEffect(() => {
        if (Object.keys(profile_account_information).length <= 0) {
            get_profile_account_information();
        } else {
            setInvoiceAddress(profile_account_information?.billTo ?? []);
            setShippingAddress(profile_account_information?.shipTo ?? []);
        }
    }, [profile_account_information]);


    const openInvoicePopup = (addressInfo) => {
        clear_all_system_alert()
        System.popup('ProfileAddressPopup', addressInfo);
    }

    const setDefaultAddress = async (id, isDefault, preferenceFilter = "") => {
        clear_all_system_alert()
        const data = {
            "preferenceType": "Default_ShipTo",
            "preferenceValue": isDefault ? "" : id,
            "preferenceFilter": preferenceFilter
        };
        const res = await set_account_address_default(data);
        if (res) {
            system_alert_indicator({
                name: 'profile',
                message: isDefault ? "Default shipping address has been removed." : "Default shipping address has been updated.",
                type: "success"
              })
            await get_profile_account_information();
            Helper.scrollTop();
        }
    };

    return (
        <>{__check("PROFILE_ACCOUNT_INFORMATION").status ? __check('PROFILE_ACCOUNT_INFORMATION').render :
            <>
                <div>
                    <div className='d-flex align-items-center justify-content-between profile-title mb-2'>
                        <div className='font-arial font-16'><b> Invoice Address</b></div>
                        <div>
                            {isWebUser && ((!Helper.valueIsNotNull(invoiceAddress)) || invoiceAddress?.length <= 0)
                                && <a onClick={() => openInvoicePopup({ 'type': addressType.BILL_TO, 'addressInfo': {} })}
                                    className='font-arial'><b>
                                        <i className="fa fa-plus me-1"></i> Add Invoice Address </b>
                                </a>}
                        </div>
                    </div>
                    {currentUser === CORE &&
                        <p className="font-arial font-16 mb-3 pb-1">In order to edit an address or add a New Invoice
                            Address, please contact your account representative.</p>}
                    <div className='mb-4'>
                        <div className='profile-box-container'>
                            {invoiceAddress?.length > 0 && invoiceAddress.map((invoiceAdd, index) => (
                                ((isCoreUser && invoiceAdd.default) || (isWebUser)) &&
                                <div className='profile-box' key={index}>
                                    <div>
                                        <div className='companyname ps-0'><b>{invoiceAdd.companyName}</b></div>
                                        <div className='companyaddress'>
                                            {invoiceAdd.address.addressLineOne}<br />
                                            {Helper.valueIsNotNull(invoiceAdd.address.addressLineTwo) && invoiceAdd.address.addressLineTwo.trim() && <>
                                                {invoiceAdd.address.addressLineTwo}<br />
                                            </>}
                                            {invoiceAdd.address.cityName}, {invoiceAdd.address.stateName} {invoiceAdd.address.postalCode}, <br />
                                            {invoiceAdd.address.countryName}.
                                        </div>
                                    </div>

                                    {isWebUser && <a onClick={() => openInvoicePopup({
                                        'type': addressType.BILL_TO,
                                        'addressInfo': invoiceAdd
                                    })}>Edit</a>}
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                <div>
                    <div className='d-flex align-items-center justify-content-between profile-title'>
                        <div className='font-arial font-16'><b> Shipping Address</b></div>
                        <div>
                            <a onClick={() => openInvoicePopup({ 'type': addressType.SHIP_TO, 'addressInfo': {} })}
                                className='font-arial'><b> {isWebUser ?
                                    <i className="fa fa-plus me-1"></i> : isCoreUser &&
                                    <i className="fa fa-address-card" aria-hidden="true"></i>} {isWebUser ? ' Add Shipping Address ' : isCoreUser ? ' Request Shipping Address' : ''}</b></a>
                        </div>
                    </div>
                    <div className='mb-4'>
                        <div className='profile-box-container'>
                            {isWebAndCoreUser && shippingAddress?.length > 0 && shippingAddress.map((shipadd, index) => (
                                <div className="profile-box-shipping-column" key={index}>
                                    <div className='profile-box-shipping'>
                                        <div className={`d-flex align-items-center justify-content-between set-default ${shipadd.default ? 'active' : ''}`}>
                                            {(shipadd.default) ? 'Default' : 'Set as Default'}
                                            <label className="whitecheckbox">
                                                <input type='checkbox'
                                                    className='m-0 check'
                                                    checked={shipadd.default}
                                                    onChange={() => setDefaultAddress(shipadd.id, shipadd.default, isCoreUser ? `${salesOrg}-${accountNumber}` : "")} />
                                                <span className="box"></span>
                                            </label>
                                        </div>
                                        <div className='profile-box'>
                                            <div className='mb-3'>
                                                <div className='companyname ps-0'><b>{shipadd.companyName}</b></div>
                                                <div className='companyaddress'>
                                                    {shipadd.address.addressLineOne}<br />
                                                    {Helper.valueIsNotNull(shipadd.address.addressLineTwo) && shipadd.address.addressLineTwo.trim() && <>
                                                        {shipadd.address.addressLineTwo}<br />
                                                    </>}
                                                    {shipadd.address.cityName}, {shipadd.address.stateName} {shipadd.address.postalCode}, <br />
                                                    {shipadd.address.countryName}.
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </>
        }
        </>
    );
};

export default AddressInformation;
